import React from "react";
import {
  Box,
  Heading,
  ListItem,
  Text,
  UnorderedList,
  Link,
  useColorModeValue,
} from "@chakra-ui/react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { DASHBOARD_TAB_GUIDES } from "../../content/productGuide";

function segmentFromPath(pathname) {
  const m = String(pathname || "").match(/^\/dashboard\/([^/?#]+)/);
  return m ? m[1] : null;
}

function DashboardTabGuideBannerInner({
  guide,
  shellBg,
  border,
  muted,
  headingCol,
  linkCol,
}) {
  if (!guide) return null;

  return (
    <Box
      borderWidth="1px"
      borderColor={border}
      borderRadius="xl"
      bg={shellBg}
      px={{ base: 4, md: 5 }}
      py={{ base: 3, md: 4 }}
      mb={4}
      boxShadow="sm"
    >
      <Heading as="h2" size="sm" fontWeight="bold" color={headingCol} mb={1}>
        {guide.title} — what this tab is for
      </Heading>
      <Text fontSize="sm" color={muted} mb={2} lineHeight="tall">
        {guide.intro}
      </Text>
      <UnorderedList
        fontSize="sm"
        color={muted}
        spacing={1}
        pl={4}
        mb={3}
        styleType="disc"
      >
        {guide.helps.map((line) => (
          <ListItem key={line} lineHeight="tall">
            {line}
          </ListItem>
        ))}
      </UnorderedList>
      <Text fontSize="xs" color={muted}>
        <Link
          as={RouterLink}
          to="/dashboard"
          color={linkCol}
          fontWeight="semibold"
          _hover={{ textDecoration: "underline" }}
        >
          Workspace home
        </Link>
        {" · "}
        Use the left menu to open other tools in Manage360.
      </Text>
    </Box>
  );
}

const DashboardTabGuideBanner = () => {
  const location = useLocation();
  const shellBg = useColorModeValue("white", "gray.800");
  const border = useColorModeValue("teal.100", "teal.700");
  const muted = useColorModeValue("gray.600", "gray.400");
  const headingCol = useColorModeValue("gray.800", "white");
  const linkCol = useColorModeValue("teal.600", "teal.300");

  const segment = segmentFromPath(location.pathname);
  const guide = segment ? DASHBOARD_TAB_GUIDES[segment] : null;

  return (
    <DashboardTabGuideBannerInner
      guide={guide}
      shellBg={shellBg}
      border={border}
      muted={muted}
      headingCol={headingCol}
      linkCol={linkCol}
    />
  );
};

export default DashboardTabGuideBanner;
